module.exports = __webpack_public_path__ + "static/media/04-mobile.8e97c010.webp";